import { ToggleButton } from '@openeducation/oe-it-components';
import { useState } from 'react';

import { ActiveClassDataTable } from './active-class-card-data-table';
import { ActiveClassCardEmpty } from './active-class-card-empty';
import { ActiveClassCardModal } from './active-class-card-modal';
import { Card } from '../../atoms/card/card';
import { useActiveClasses } from '../../hooks/use-active-classes';
import { useActiveClassesStatus } from '../../hooks/use-active-classes-status';
import { useRole } from '../../hooks/use-role';

export interface ActiveClassCardProps {
  teacherId: number;
}
export const ActiveClassCard = ({ teacherId }: ActiveClassCardProps) => {
  const { isTeacher, isAdmin } = useRole();

  const {
    activeClasses,
    totalStudent,
    isLoadingActiveClasses,
    reassignTeacher,
  } = useActiveClasses({ teacherId, isEnabled: !isTeacher });

  const {
    enableLiveClasses,
    disableLiveClasses,
    activeClassesStatus,
    isLoadingActiveClassesStatus,
    isLoadingChangeActiveClassesStatus,
  } = useActiveClassesStatus();

  const [modalActiveClassesEnabled, setModalActiveClassesEnabled] =
    useState(false);

  const handleToogleStatus = () => {
    if (activeClassesStatus) {
      disableLiveClasses();
    } else {
      enableLiveClasses();
    }
    setModalActiveClassesEnabled(false);
  };

  if (isTeacher) {
    return null;
  }
  return (
    <Card
      title={`Active Classes (${activeClasses?.length || 0})`}
      fullWidth
      rightContent={
        isAdmin && (
          <ToggleButton
            selected={activeClassesStatus}
            isLoading={
              isLoadingActiveClassesStatus || isLoadingChangeActiveClassesStatus
            }
            onChange={() => setModalActiveClassesEnabled((prev) => !prev)}
            label="Live Classes Enabled"
          />
        )
      }
    >
      {!isLoadingActiveClasses && !activeClasses?.length ? (
        <ActiveClassCardEmpty />
      ) : (
        <ActiveClassDataTable
          totalStudent={totalStudent}
          activeClasses={activeClasses}
          isLoading={isLoadingActiveClasses}
          onReassignTeacher={reassignTeacher}
        />
      )}
      <ActiveClassCardModal
        onClose={() => setModalActiveClassesEnabled(false)}
        onConfirm={() => handleToogleStatus()}
        isVisible={modalActiveClassesEnabled}
        isActive={activeClassesStatus}
      />
    </Card>
  );
};
